import React from 'react'

function Footer() {
  return (
    <div className="footer-section bg-primary py-28 relative z-10 bg-sky-950 py-[90px] px-10">
  <div className="container mx-auto">
    <div className="row">
      <div className="col-lg-12">
        <div className="footer_widget_upper flex items-center justify-between border-b border-white/20 pb-10 mb-6">
          <div className="company-logo cursor-pointer">
          <span className="text-4xl font-extrabold text-slate-100 group-hover:text-white tracking-wide  decoration-indigo-500 decoration-2">
  PREVOMICS
</span>
          </div>
          <div className="footer_title relative pl-16">
            <h2 className="text-2xl text-white font-medium">
              We are here to help YOU
            </h2>
            <span className="absolute left-0 top-4 w-16 h-[2px] bg-secondary"></span>
          </div>
        </div>
      </div>
    </div>

    <div className="    grid gap-x-8 gap-y-8 grid-cols-1 sm:grid-cols-3 lg:grid-cols- px-3">
      <div className="col-lg-5 col-md-6">
        <div className="widget widgets-company-info" data-aos="zoom-in-right">
          <h4 className="widget-title text-xl text-white font-medium pb-6">About Us</h4>
          <div className="company-info-desc text-white/60 mb-4">
            <p>
              Completely e-enable covalent functionalities and medical
              positioning infomediarie interactively
            </p>
          </div>
          <div className="footer-mediket-contact space-y-4">
            <div className="mediket-info text-white">
              <h5>Friends Appartment <br />NY 10003 - USA</h5>
            </div>
            <div className="mediket-info text-white">
              <h5>+91 6350085319</h5>
            </div>
            <div className="mediket-info text-white">
              <h5>prevomics@gmail.com</h5>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="widget widget-nav-menu" data-aos="zoom-out">
          <h4 className="widget-title text-xl text-white font-medium pb-6">Services Links</h4>
          <ul className="footer-menu space-y-2">
            {['Cardiology', 'Orthopedics', 'Nurology', 'Dermatology', 'Dental Care', 'Sugery'].map(
              (item, index) => (
                <li key={index} className="text-white/75 hover:text-light transition">
                  <a href="#" className="relative pl-4">
                    {item}
                    <span className="absolute left-0 top-2 w-2 h-2 rounded-full bg-blue-500 opacity-0 hover:opacity-100"></span>
                  </a>
                </li>
              )
            )}
          </ul>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="mediket-address" data-aos="zoom-in-left">
          <h4 className="widget-title text-xl text-white font-medium pb-6">Subscribe Newsletter</h4>
          <div className="footer_widget_anytime_alarm flex items-center gap-4 mt-2">
            <div className="anytime_alarm bg-white/10 w-9 h-9 flex items-center justify-center rounded-full">
              <i className="fa-regular fa-bell text-secondary"></i>
            </div>
            <p className="text-white/80">Signup our newsletter for lates updates from our medical anytime</p>
          </div>
          <form className="relative mt-6">
            <input
              type="email"
              name="email"
              placeholder="hello@gmail.com"
              className="w-full bg-transparent border border-white/20 px-6 h-16 text-white rounded-full focus:outline-none"
            />
            <button
              type="submit"
              className="absolute right-4 top-2/4 transform -translate-y-2/4 bg-blue-500 w-9 h-9 flex items-center justify-center rounded-full">
              <i className="flaticon flaticon-right-arrow text-white"></i>
            </button>
          </form>
         
        </div>
      </div>
    </div>

    <div className="row footer-btm mt-36">
      <div className="col-lg-6 col-md-6">
        <p className="text-white italic">
          Copyright © 2025 Prevomics. Design By - Adrologic
        </p>
      </div>
      <div className="col-lg-6 col-md-6">
        <ul className="flex justify-end space-x-6">
          {['FACEBOOK', 'TWITTER', 'INSTAGRAM'].map((platform, index) => (
            <li key={index}>
              <a href="#" className="text-white/75 hover:text-light transition">
                {platform}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
</div>

  )
}

export default Footer